import React, { useState } from "react";
import styles from "./inputs.module.css";
function InputNumber(props) {
  const min = 0;
  const max = 5;

  const [maleValue, setMaleValue] = useState(0);
  const [femaleValue, setFemaleValue] = useState(0);
  const [othersValue, setOthersValue] = useState(0);

  const maleIncrement = () => {
    if (typeof max === "number" && maleValue >= max) return;
    setMaleValue(maleValue + 1);
  };

  const maleDecrement = () => {
    if (typeof min === "number" && maleValue <= min) return;
    setMaleValue(maleValue - 1);
  };
  const FemaleIncrement = () => {
    if (typeof max === "number" && femaleValue >= max) return;
    setFemaleValue(femaleValue + 1);
  };

  const FemaleDecrement = () => {
    if (typeof min === "number" && femaleValue <= min) return;
    setFemaleValue(femaleValue - 1);
  };
  const othersIncrement = () => {
    if (typeof max === "number" && othersValue >= max) return;
    setOthersValue(othersValue + 1);
  };

  const othersDecrement = () => {
    if (typeof min === "number" && othersValue <= min) return;
    setOthersValue(othersValue - 1);
  };

  return (
    <div className={styles.all}>
      <div className={`${styles.titleNumbers} ${styles.maleTitle}`}>
        <div>Males: </div>
        <div className={styles.InputNumbers}>
          <button type="button" onClick={maleDecrement}>
            &minus;
          </button>
          <span>{maleValue}</span>
          <button type="button" onClick={maleIncrement}>
            &#43;
          </button>
        </div>
      </div>
      <div className={styles.titleNumbers}>
        <div>Females: </div>
        <div className={`${styles.InputNumbers} ${styles.females}`}>
          <button type="button" onClick={FemaleDecrement}>
            &minus;
          </button>
          <span>{femaleValue}</span>
          <button type="button" onClick={FemaleIncrement}>
            &#43;
          </button>
        </div>
      </div>
      <div className={`${styles.titleNumbers} ${styles.otherTitle}`}>
        <div>Others: </div>
        <div className={`${styles.InputNumbers} ${styles.others}`}>
          <button type="button" onClick={othersDecrement}>
            &minus;
          </button>
          <span>{othersValue}</span>
          <button type="button" onClick={othersIncrement}>
            &#43;
          </button>
        </div>
      </div>
    </div>
  );
}

export default InputNumber;
